export const NAMESPACE = 'WEIGHT_SYNC';